<div class="container h-100">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!isLoading">
    <div *ngIf="(signupComplete) && (signupForm.get('email') != '') &&
    (signupForm.get('email') != null)" class="card-footer alert alert-success col-12 col-xs-9 col-lg-8 VerticalMargin"
      [class.SmallArabicFont]="globalService.isRTL == true">
      {{ globalService.Get("ACCOUNTACTIVATED") }}
      <a href="https://{{ tenantSubdomain }}.{{ getDomain() }}.org/">{{ globalService.Get("HERE") }}</a>
    </div>
    <div *ngIf="(signupComplete) && ((signupForm.get('email') == null) || (signupForm.get('email') == ''))"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8 VerticalMargin"
      [class.SmallArabicFont]="globalService.isRTL == true">
      {{ globalService.Get("PHONEACCOUNTACTIVATED") }}
      <a href="https://{{ tenantSubdomain }}.{{ getDomain() }}.org/">{{ globalService.Get("HERE") }}</a>
    </div>
    <div class="card MyForm RegularForm rounded col-12 col-xs-9 col-lg-8" *ngIf="!isLoading && !signupComplete">
      <div class="card-body MyCardBody rounded-bottom">
        <div *ngIf="subscriptionError == true" class="text-center">
          <div class="text-danger">Subscription limit has been reached. Please contact the church admin.</div>
          <br>
          <button class="btn btn-secondary m-auto" routerLink="/login">
            {{ globalService.Get("CLOSE") }}
          </button>
        </div>
        <form *ngIf="signupForm && (subscriptionError == false)" [formGroup]="signupForm" (ngSubmit)="onSubmit()"
          autocomplete="off" name="dummy">
          <div class="row">
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="email">{{ globalService.Get("EMAIL") }}</label>
              <input type="email" id="email" class="form-control" formControlName="email" autocomplete="new-email"
                (keypress)="keyPressNumbers($event)" dir="ltr" />
              <small class="help-block" *ngIf="
                  !signupForm.get('email').valid &&
                  (signupForm.get('email').touched || submit)
                ">{{ globalService.Get("VALIDEMAIL") }}</small>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="firstName">{{
                globalService.Get("FIRSTNAME")
                }}</label>
              <input type="text" id="firstName" class="form-control" autocomplete="off" formControlName="firstName"
                autocomplete="new-firstName" />
              <small class="help-block" *ngIf="
                  !signupForm.get('firstName').valid &&
                  (signupForm.get('firstName').touched || submit)
                ">{{ globalService.Get("FIRSTNAME_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="lastName">{{ globalService.Get("LASTNAME") }}</label>
              <input type="text" id="lastName" class="form-control" autocomplete="off" formControlName="lastName"
                autocomplete="new-lastName" />
              <small class="help-block" *ngIf="
                  !signupForm.get('lastName').valid &&
                  (signupForm.get('lastName').touched || submit)
                ">{{ globalService.Get("LASTNAME_REQUIRED") }}</small>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="street">{{ globalService.Get("STREET") }}</label>
              <input type="text" id="street" class="form-control" autocomplete="off" formControlName="street"
                autocomplete="new-street" />
              <small class="help-block" *ngIf="
                  !signupForm.get('street').valid &&
                  (signupForm.get('street').touched || submit)
                ">{{ globalService.Get("STREET_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="city">{{ globalService.Get("CITY") }}</label>
              <input type="text" id="city" class="form-control" autocomplete="off" formControlName="city"
                autocomplete="new-city" />
              <small class="help-block" *ngIf="
                  !signupForm.get('city').valid &&
                  (signupForm.get('city').touched || submit)
                ">{{ globalService.Get("CITY_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="state">{{ globalService.Get("STATE") }}</label>
              <input type="state" id="state" class="form-control" autocomplete="off" formControlName="state"
                autocomplete="new-state" />
              <small class="help-block" *ngIf="
                  !signupForm.get('state').valid &&
                  (signupForm.get('state').touched || submit)
                ">{{ globalService.Get("STATE_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="zip">{{ globalService.Get("ZIP") }}</label>
              <input type="zip" id="zip" class="form-control" autocomplete="off" formControlName="zip"
                autocomplete="new-zip" />
              <small class="help-block" *ngIf="
                  !signupForm.get('zip').valid &&
                  (signupForm.get('zip').touched || submit)
                ">{{ globalService.Get("ZIP_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="country">{{ globalService.Get("COUNTRY") }}</label>
              <select id="country" class="form-control text-left classic" dir="ltr" style="text-align: left"
                formControlName="country" (change)="OnCountryChange()">
                <option *ngFor="let country of countriesArr" [ngValue]="country.code">
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
            [class.ArabicFont]="globalService.isRTL == true" *ngIf="isConfirmed == true && phoneNumber != ''">
              <label for="cellPhone">{{ globalService.Get("CELLPHONE") }}</label>
              <div class="row">
                <div class="col-6"><input type="text" id="phoneNumber" class="form-control" disabled="true"
                    autocomplete="off" formControlName="phoneNumber" /> </div>
                <div class="col-6"><button class="btn btn-secondary m-auto" (click)="UpdatePhone()">
                    {{ globalService.Get("CLEAR") }}
                  </button> </div>
              </div>
            </div>
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
            [class.ArabicFont]="globalService.isRTL == true" *ngIf="isConfirmed == false || phoneNumber == ''">
              <app-phone-verify [dial_code]="dial_code" [enabled]="true" [phone_number]=" "
                (failed)="failedVerification()" (clearEvent)="clearCellPhone()"
                (confirmNumber)="ConfirmCellPhone($event)"></app-phone-verify>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="dateOfBirth">{{ globalService.Get("DOB") }}</label>
              <div>
                <div class="input-group" dir="ltr">
                  <input id="dateOfBirth" formControlName="dateOfBirth" class="form-control" matInput
                    [matDatepicker]="dateOfBirth" placeholder="MM/DD/YYYY" required [min]="minDate" [max]="maxDate"
                    (click)="globalService.OpenCalendar(dateOfBirth)" />
                  <mat-datepicker [touchUi]="
                      (globalService.isHandset$ | async) ? 'true' : 'false'
                    " #dateOfBirth></mat-datepicker>
                  <div class="input-group-append">
                    <button type="button" class="btn btn-secondary btn-small input-group-text"
                      (click)="globalService.OpenCalendar(dateOfBirth)">
                      <span>
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <small class="help-block" *ngIf="
                  !signupForm.get('dateOfBirth').valid &&
                  (signupForm.get('dateOfBirth').touched || submit)
                ">{{ globalService.Get("DOB_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="maritalStatus">{{
                globalService.Get("MARITAL_STATUS")
                }}</label>
              <select id="maritalStatus" class="form-control" formControlName="maritalStatus"
                [class.classicRTL]="globalService.isRTL == true" [class.class]="globalService.isRTL == false">
                <option [ngValue]="null">
                  {{ globalService.Get("SELECT") }}
                </option>
                <option [ngValue]="0">{{ globalService.Get("SINGLE") }}</option>
                <option [ngValue]="1">
                  {{ globalService.Get("ENGAGED") }}
                </option>
                <option [ngValue]="2">
                  {{ globalService.Get("MARRIED") }}
                </option>
                <option [ngValue]="3">
                  {{ globalService.Get("WIDOWED") }}
                </option>
                <option [ngValue]="4">
                  {{ globalService.Get("DIVORCED") }}
                </option>
              </select>
              <small class="help-block" *ngIf="
                  !signupForm.get('maritalStatus').valid &&
                  (signupForm.get('maritalStatus').touched || submit)
                ">{{ globalService.Get("MARITAL_STATUS_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="gender">{{ globalService.Get("GENDER") }}</label>
              <select id="gender" class="form-control" formControlName="gender"
                [class.classicRTL]="globalService.isRTL == true" [class.class]="globalService.isRTL == false">
                <option [ngValue]="null" disabled>
                  {{ globalService.Get("SELECT") }}
                </option>
                <option [ngValue]="false">
                  {{ globalService.Get("MALE") }}
                </option>
                <option [ngValue]="true">
                  {{ globalService.Get("FEMALE") }}
                </option>
              </select>
              <small class="help-block" *ngIf="
                  !signupForm.get('gender').valid &&
                  (signupForm.get('gender').touched || submit)
                ">{{ globalService.Get("GENDER_REQUIRED") }}</small> 
            </div>

            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
            [class.ArabicFont]="globalService.isRTL == true">
              <label for="occupation">{{ globalService.Get("OCCUPATION") }}</label>
              <div>
                <select id="occupation" class="form-control" [class.classicRTL]="globalService.isRTL == true"
                  [class.classic]="globalService.isRTL == false" formControlName="occupation">
                  <option [ngValue]="null" disabled>
                    {{ globalService.Get("SELECT") }}
                  </option>
                  <option *ngFor="let occupation of occupations" [ngValue]="occupation.id">
                    {{ occupation.name }}
                  </option>
                </select>
                <small class="help-block" *ngIf="
                !signupForm.get('occupation').valid &&
                (signupForm.get('occupation').touched || submit)
              ">{{ globalService.Get("OCCUPATION_REQUIRED") }}</small>                
              </div>
            </div>  

            <ng-container formArrayName="extensions" class="col">
              <div *ngFor="let extension of extensions.controls; let i = index" class="form-group col-12 col-md-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
                <div [formGroupName]="i">
                  <label> {{ extension.get("label").value }} </label>
                  <div *ngIf="extension.get('options').value == null">
                    <input type="text" class="form-control" formControlName="value" />
                    <small class="help-block" *ngIf="
                    !extension.get('value').valid &&
                    (extension.get('value').touched || submit)
                  ">{{ extension.get("label").value }} Required</small>
                  </div>
                  <div *ngIf="extension.get('options').value != null">
                    <select class="form-control" [class.classicRTL]="globalService.isRTL == true" formControlName="value"
                      [class.classic]="globalService.isRTL == false">
                      <option [ngValue]="null" disabled>{{ globalService.Get("SELECT") }}</option>
                      <option *ngFor="let option of extension.get('options').value" [ngValue]="option">
                        {{ option }}
                      </option>
                    </select>
                    <small class="help-block" *ngIf="
                    !extension.get('value').valid &&
                    (extension.get('value').touched || submit)
                  ">{{ extension.get("label").value }} Required</small>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="isMember text-dark">{{ globalService.Get("IS_PRIMARY_CHURCH") }}</label>
              <select id="isMember" class="form-control" formControlName="isMember"
                [class.classicRTL]="globalService.isRTL == true" [class.class]="globalService.isRTL == false">
                <option [ngValue]="null" disabled>
                  {{ globalService.Get("SELECT") }}
                </option>
                <option [ngValue]="true">
                  {{ globalService.Get("YES") }}
                </option>
                <option [ngValue]="false">
                  {{ globalService.Get("NO") }}
                </option>
              </select>
              <small class="help-block" *ngIf="
                  !signupForm.get('isMember').valid &&
                  (signupForm.get('isMember').touched || submit)
                ">{{ globalService.Get("MEMBER_REQUIRED") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="password">{{ globalService.Get("PASSWORD") }}</label>
              <input type="password" id="password" class="form-control" dir="ltr" formControlName="password"
                autocomplete="new-password" (keypress)="keyPressNumbers($event)" />
              <small class="help-block" *ngIf="
                  !signupForm.get('password').valid &&
                  (signupForm.get('password').touched || submit)
                ">
                {{ globalService.Get("PASSWORD_RESTRICTIONS") }}</small>
            </div>
            <div class="form-group col-6" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <label for="confirmPassword">{{
                globalService.Get("CONFIRM_PASSWORD")
                }}</label>
              <input type="password" dir="ltr" id="confirmPassword" class="form-control"
                formControlName="confirmPassword" autocomplete="new-confirmPassword"
                (keypress)="keyPressNumbers($event)" />
              <small class="help-block" *ngIf="
                  signupForm.errors?.passwordMismatch &&
                  (signupForm.get('confirmPassword').touched || submit) &&
                  (signupForm.get('password').touched || submit)
                ">{{ globalService.Get("PASSWORD_MISMATCH") }}</small>
            </div>
          </div>
          <div class="row nomargin mt-3">
            <div class="form-group col-10" [class.ml-4]="globalService.isRTL == false"
              [class.mr-4]="globalService.isRTL == true">
              <input type="checkbox" class="form-check-input" [checked]="agreementAccepted"
                (click)="AcceptAgreement($event.target.checked)" />
              <label class="form-check-label" [class.mr-4]="globalService.isRTL == true">{{
                globalService.Get("AGREE_TO_TERMS") }}
                <a href="{{ agreementUrl }}" target='self'>{{
                  globalService.Get("CLICK_TO_REVIEW")
                  }} </a></label> 
            </div>
          </div>
          <div class="row nomargin">
            <div class="form-group col-10" [class.ml-4]="globalService.isRTL == false"
              [class.mr-4]="globalService.isRTL == true">
              <input type="checkbox" class="form-check-input" [checked]="textAccepted"
                (click)="AcceptText($event.target.checked)" />
              <label class="form-check-label" [class.mr-4]="globalService.isRTL == true">{{
                globalService.Get("OPTIN_TEXT") }} {{ churchName }}</label>
            </div>
          </div>          
          <ngb-alert *ngIf="!failureClosed && error" [type]="'danger'" class="text-center my-2"
            (close)="failureClosed = true" [class.ArabicFont]="globalService.isRTL == true">
            {{ globalService.Get(error) }}
          </ngb-alert>
          <div class="row">
            <div class="form-group mt-3 col-12" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <button class="btn btn-block btn-primary m-auto" [disabled]="agreementAccepted == false || textAccepted == false"
                type="submitReactiveFormsModule">
                {{ globalService.Get("CREATEACCOUNT") }}
              </button>
            </div>
            <div class="form-group col-12" [class.text-right]="globalService.isRTL == true"
              [class.ArabicFont]="globalService.isRTL == true">
              <button class="btn btn-block btn-secondary m-auto" routerLink="/login">
                {{ globalService.Get("CLOSE") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>